import React from 'react';
import { useSettings } from '../contexts/SettingsContext';

const AnalyticsScripts = () => {
    const { customHead, customBody } = useSettings();

    // customHeadの内容をパースしてbody要素内に入れるべき内容（noscriptなど）を抽出
    const extractBodyContent = (htmlString) => {
        if (!htmlString) return '';

        // noscriptタグを抽出
        const noscriptMatches = htmlString.match(/<noscript[^>]*>[\s\S]*?<\/noscript>/gi);
        return noscriptMatches ? noscriptMatches.join('\n') : '';
    };

    // head要素に直接挿入するための処理
    React.useEffect(() => {
        if (!customHead) return;

        // head要素からnoscriptタグを除去したものを作成
        const headOnlyContent = customHead.replace(/<noscript[^>]*>[\s\S]*?<\/noscript>/gi, '');

        if (headOnlyContent.trim()) {
            // 一時的なdiv要素を作成してHTMLを解析
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = headOnlyContent;

            // すべての子要素をhead要素に追加
            Array.from(tempDiv.children).forEach(element => {
                // 重複チェック（同じ内容の要素が既に存在する場合はスキップ）
                const existingElements = document.head.querySelectorAll(element.tagName);
                let isDuplicate = false;

                existingElements.forEach(existing => {
                    if (existing.outerHTML === element.outerHTML) {
                        isDuplicate = true;
                    }
                });

                if (!isDuplicate) {
                    document.head.appendChild(element.cloneNode(true));
                }
            });
        }

        // クリーンアップ関数（コンポーネントがアンマウントされたときに追加した要素を削除）
        return () => {
            // 必要に応じてクリーンアップ処理を実装
        };
    }, [customHead]);

    // customBodyを<body>直下に完全な形で挿入
    React.useEffect(() => {
        // カスタムbody領域を管理するコンテナを作成
        const customBodyRegion = document.getElementById('custom-body-region');
        if (customBodyRegion) {
            customBodyRegion.remove();
        }

        // カスタムbodyが存在する場合、領域コンテナを作成
        if (customBody && customBody.trim()) {
            const region = document.createElement('div');
            region.id = 'custom-body-region';
            region.style.display = 'contents'; // 視覚的に存在しないコンテナ
            
            // カスタムbodyの内容をそのまま挿入
            region.innerHTML = customBody;
            
            // <div id="root">の直前に挿入
            const rootElement = document.getElementById('root');
            if (rootElement) {
                document.body.insertBefore(region, rootElement);
            } else {
                // rootがない場合は最初に挿入
                document.body.insertBefore(region, document.body.firstChild);
            }
        }

        // クリーンアップ関数
        return () => {
            const region = document.getElementById('custom-body-region');
            if (region) {
                region.remove();
            }
        };
    }, [customBody]);

    const bodyContent = extractBodyContent(customHead);

    return (
        <>
            {/* noscriptタグなどのbody内容（customHeadから抽出） */}
            {bodyContent && (
                <div dangerouslySetInnerHTML={{ __html: bodyContent }} />
            )}

            {/* カスタムbodyはuseEffectでDOM操作により<body>直下に配置されるため、ここでは出力しない */}
        </>
    );
};

export default AnalyticsScripts; 